//
// 指定されたコンテンツをクリップボードにコピー
//
import { toast } from './toast.js'

document.addEventListener("DOMContentLoaded", (_event) => {
  const copyLinks = document.getElementsByClassName("copy-content");
  if (copyLinks.length == 0) return;

  const mainContent = document.querySelector(".main");

  const copyContentHandler = (e) => {
    const url = e.target.dataset["content"];
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
      e.preventDefault();
    } else if (window.clipboardData) {
      window.clipboardData.setData("Text", url);
      e.preventDefault();
    }

    for (const el of document.querySelectorAll(".main .toast")) {
      el.style["display"] = "none"
    }

    toast("コピーしました", mainContent);
  };

  for (const link of copyLinks) {
    link.addEventListener("click", copyContentHandler);
  }
});
